<app-loading-generico [message]="loadingGenericoMessage" [loadingGenerico]="loadingGenerico"
[buttons]="loadingGenericoData.buttons"></app-loading-generico>
<app-header></app-header>
<app-botao-chat></app-botao-chat>
<app-alert-sucesso-padrao (alertSucessoFechou)="sucessoFechou()"
  [descricaoSucesso]="'A planilha foi gerada e o download do arquivo foi feito pra o seu dispositivo.'"
  [showSucesso]="showAlertSucesso">
</app-alert-sucesso-padrao>
<app-alert-erro-padrao [showAlertaErro]="showAlertErro"
  (alertErroPadraoFechou)="alertaErroFechou()"
  [descricaoErro]="'Ocorreu um erro ao gerar planilha. Favor tentar novamente mais tarde.'"
></app-alert-erro-padrao>
<app-alert-descartar-alteracoes [show]="showAlertDescarte"
  (confirmouDescarte)="limparFiltro()"
(cancelouDescarte)="fecharAlertDescartarAleracoes()"></app-alert-descartar-alteracoes>
<div class="container py-4">
  <div class="row">
    <div class="col-12">
      <div class="card mb-4">
        <app-breadcrumb></app-breadcrumb>
        <div class="div-titulo-pagina">
          <h1>Gerar planilha de dados</h1>
          <h2>Escolha as opções e monte sua planilha</h2>
        </div>
        <div class="gerar-planilha-dados">
          <div class="top-filtro-planilha">
            <app-select-one [label]="'UF'"
              class="filtro-estado-planilha"
              [selectedValue]="idEstado"
              descricaoPadrao="Todos"
              valorPadrao="0"
              id="slctEstado"
              [pipeName]="pipeName"
              (valueChanges)="onChangeEstado($event)"
              [collection]="ufList"
              [panelWidth]="'500px'">
            </app-select-one>
            <app-select-one [label]="'Cidade'"
              class="filtro-cidade-planilha"
              [buscaComPesquisa]="false"
              [selectedValue]="idCidade"
              descricaoPadrao="Todas as cidades"
              valorPadrao="0"
              id="slctCidade"
              (valueChanges)="onChangeCidade($event)"
              [collection]="cidadesFiltered"
              [panelWidth]="'500px'">
            </app-select-one>
          </div>
          <div class="endereco-filtro-planilha">
            <app-select-one [label]="'Selecione o endereço'"
              class="filtro-endereco-planilha"
              [buscaComPesquisa]="true"
              [selectedValue]="idEndere"
              valorPadrao="0"
              descricaoPadrao="Todos"
              id="slctEndereco"
              (valueChanges)="idEndere = $event"
              [collection]="enderecosFiltered"
              [panelWidth]="'1000px'">
            </app-select-one>
          </div>
          <div class="bottom-filtro-planilha">
            <app-select-one [label]="'Departamento'"
              class="filtro-endereco-planilha"
              [selectedValue]="idDepart"
              descricaoPadrao="Todos"
              valorPadrao="0"
              id="slctDepartamento"
              (valueChanges)="idDepart = $event"
              [collection]="departamentos"
              [panelWidth]="'500px'">
            </app-select-one>
            <app-select-one [label]="'Situação'"
              class="filtro-endereco-planilha"
              [selectedValue]="flagAtivos"
              id="slctSituacao"
              [panelWidth]="'500px'"
              (valueChanges)="flagAtivos = $event"
                            [collection]="[
              {label : 'Todos' , id : 'T'},
              {label : 'Usuários ativos' , id : 'S'},
              {label : 'Usuários inativos' , id : 'N'}
              ]">
            </app-select-one>
          </div>
          <div class="div-botao-gerar">
            <div>
              @if (campoFiltroPreenchido()) {
                <button
                  class="filtro-limpar btn border-0 bg-transparent p-0"
                  (click)="showAlertDescarte = true"
                  aria-label="Limpar filtro">
                  LIMPAR FILTRO
                </button>
              }
            </div>
            <button type="button" class="botao-padrao btn-grande-verde" id="btnListar"
                    [disabled]="!('FerramentasGerarPlanilhaDeDados' | usuarioPermissao:'Imprimir' | async)" [ngClass]="{
                disabled: !('FerramentasGerarPlanilhaDeDados' | usuarioPermissao:'Imprimir' | async)
              }" (click)='startFileGeneration("xls")'>GERAR PLANILHA
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
